<template>
  <div class="container">
    <h1>Subscription Details</h1>
    <div class="row margin-bottom-2 margin-bottom-1">
      <div class="col-xs-4">
        <DevAppDropDownComponent role="sms" @devapp-changed="devAppChanged" />
      </div>
    </div>
    <sdx-loading-spinner id="spinner-subscription-content" size="large"
                         sr-hint="Loading. Please wait."></sdx-loading-spinner>
    <div id="subscription-content" v-if="showSubscription" class="margin-top-4">
        <div class="row padding-1">
          <div class="col-xs-4 font--semi-bold ">SMS National Sender Text</div>
          <div class="col-xs-4">{{ subscriptionDetails.scs_messaging_sms_v2_domesticSenderText }}</div>
        </div>
        <div class="row margin-top-1 padding-1 bg-horizon">
          <div class="col-xs-4 font--semi-bold">SMS International Sender Text</div>
          <div class="col-xs-4">{{ subscriptionDetails.scs_messaging_sms_v2_internationalSenderText }}</div>
        </div>
        <div class="row padding-1 margin-top-1"
             v-if="subscriptionDetails.scs_messaging_sms_v2_internationalSenderText_registered_numeric">
          <div class="col-xs-4 margin-left-1">
            Override for countries<br/>which have SMS registration as a numeric sender text
          </div>
          <div class="col-xs-4 col-align-bottom">
            <br/>
            {{ subscriptionDetails.scs_messaging_sms_v2_internationalSenderText_registered_numeric }}
          </div>
        </div>
        <div class="row padding-1 margin-top-1 bg-horizon"
             v-if="subscriptionDetails.scs_messaging_sms_v2_internationalSenderText_registered_alphanumeric">
          <div class="col-xs-4 margin-left-1">
            Override for countries<br/>which have SMS registration as an alphanumeric sender text
          </div>
          <div class="col-xs-4 col-align-bottom" >
            <br/>
            {{ subscriptionDetails.scs_messaging_sms_v2_internationalSenderText_registered_alphanumeric }}
          </div>
        </div>
        <div v-if="subscriptionDetails.scs_messaging_sms_v2_price_swisscom">
          <div class="row margin-top-3">
            <div class="col-xs-4 font--semi-bold">SMS price</div>
          </div>
          <div class="row padding-1 margin-top-0 bg-horizon">
            <div class="col-xs-4 font--semi-bold margin-left-1">for Swisscom recipient</div>
            <div class="col-xs-4">{{ subscriptionDetails.scs_messaging_sms_v2_price_swisscom }}</div>
          </div>
          <div class="row padding-1 margin-top-0">
            <div class="col-xs-4 font--semi-bold margin-left-1">for recipient in Switzerland</div>
            <div class="col-xs-4">{{ subscriptionDetails.scs_messaging_sms_v2_price_national }}</div>
          </div>
          <div class="row padding-1 margin-top-0 bg-horizon">
            <div class="col-xs-4 font--semi-bold margin-left-1">for international recipient</div>
            <div class="col-xs-4">{{ subscriptionDetails.scs_messaging_sms_v2_price_international }}</div>

          </div>
        </div>
      </div>
    </div>
</template>


<script>
import subscriptionService from '../service'
import loadingSpinnerService from '@/services/loading-spinner.service';
import DevAppDropDownComponent from "@/components/DevAppDropDownComponent";
import {logger} from "@/services/logger.service";
import {showAlert} from "@/services/notification.service";

export default {
  components: {
    DevAppDropDownComponent,
  },
  data: function () {
    return {
      webId: undefined,
      subscriptionDetails: [],
      showSubscription: false,
    }
  },
  created() {
    this.loadData();
  },
  methods: {
    devAppChanged: async function (webId) {
      this.webId = webId;
      await this.loadData();
    },
    loadData: async function () {
      logger.debug("Loading subscription...")
      loadingSpinnerService.show("subscription-content")
      if (this.webId === undefined || this.webId === null || this.webId === '') {
        this.showSubscription = false
      } else {
        this.showSubscription = true;
        this.isLoading = true;

        try {
          let response = await subscriptionService.getSubscriptionDetails(this.webId);
          this.subscriptionDetails = response.data;
        } catch (error) {
          showAlert(error.message)
          this.subscriptionDetails = []
        }
        this.isLoading = false;
      }
      loadingSpinnerService.hide("subscription-content");
    }

  }
};
</script>

<style>
  .col-align-bottom{
    position: absolute;
    bottom: 0;
  }

</style>
